module.exports = __webpack_public_path__ + "img/box_hydrogen_grey.54a74fbd.png";